<template>
  <!-- eslint-disable vue/no-multiple-template-root -->
  <nav-breadcrumb
    :breadcrumb-data="dataBreadCrumb"
    :brands="visibleBrands"
    :brands-loading="brandsLoading"
  />
  <error-message />
  <div class="row my-3 g-0 g-lg-3">
    <div
      class="order-0 d-flex d-md-none border border-light-subtle shadow py-2 px-3 mb-3 flex-column justify-content-between align-items-start row-gap-1"
    >
      <div
        class="col-12 d-flex flex-row justify-content-between align-items-center"
      >
        <h1 class="fs-2 text-primary fw-bold mb-1 text-left">Arma tu SetUP</h1>
        <div class="d-flex justify-content-end mt-1">
          <button
            v-if="isUserAuthenticated"
            class="btn border-0 border-light-subtle mx-1"
            :style="{ width: '40px' }"
            :disabled="!canSave"
            title="Guardar"
            aria-label="Guardar"
            @click="saveAssembly()"
          >
            <i class="bi bi-bookmark-plus" />
          </button>
          <button
            v-if="isUserAuthenticated && pos != '1'"
            class="btn border-0 border-light-subtle mx-1"
            :style="{ width: '40px' }"
            :disabled="!canDuplicateAndShare"
            title="Duplicar"
            aria-label="Duplicar"
            @click="duplicateAssembly()"
          >
            <i class="bi bi-copy" />
          </button>
          <button-social-share
            :disabled="!canDuplicateAndShare"
            :share-url="urlFull"
          />
          <button
            class="btn border-0 border-light-subtle mx-1"
            :style="{ width: '40px' }"
            title="Nuevo ensamble"
            aria-label="Nuevo ensamble"
            @click="createNewAssembly"
          >
            <i class="bi bi-bookmark"></i>
          </button>
        </div>
      </div>
      <div class="mx-2">
        <input-name />
      </div>
    </div>
    <div class="order-2 order-lg-1 col-12 col-lg-9 col-xl-10">
      <div
        class="d-none d-md-flex border border-light-subtle shadow py-2 px-3 mb-3 flex-column flex-xl-row justify-content-between align-items-center"
      >
        <div class="d-flex justify-content-between align-items-center">
          <h1 class="fs-1 text-primary fw-bold mb-0">Arma tu SetUP</h1>
          <div class="mx-5 flex-grow-1 d-flex justify-content-start">
            <input-name />
            <button
              class="btn btn-danger border border-light-subtle mx-3"
              @click="showAssembly()"
            >
              <i class="bi bi-ui-checks"></i>
              Ver ensamble
            </button>
          </div>
        </div>
        <div class="flex-grow-1">
          <div
            class="d-flex justify-content-center justify-content-xl-end flex-wrap"
          >
            <div
              :id="buttonSaveId"
              class="d-flex"
              tabindex="0"
              data-bs-toggle="tooltip"
              data-bs-custom-class="custom-tooltip"
            >
              <button
                class="btn border border-light-subtle m-1 m-xl-2"
                :style="{ width: '150px', height: '50px' }"
                :disabled="isSaving"
                @click="canSave ? saveAssembly() : goToLogin()"
              >
                <i class="bi bi-heart-fill me-2" />
                Guardar
              </button>
            </div>
            <div
              :id="buttonDuplicateId"
              class="d-flex"
              tabindex="0"
              data-bs-toggle="tooltip"
              :data-bs-title="messageDisabledDuplicateButton"
              data-bs-custom-class="custom-tooltip"
            >
              <button
                v-if="pos != '1'"
                class="btn border border-light-subtle m-1 m-xl-2"
                :style="{ width: '150px', height: '50px' }"
                @click="
                  canDuplicateAndShare ? duplicateAssembly() : goToLogin()
                "
              >
                <i class="bi bi-copy me-2" />
                Duplicar
              </button>
            </div>
            <div
              :id="buttonShareId"
              class="d-flex m-1 m-xl-2"
              tabindex="0"
              data-bs-toggle="tooltip"
              :data-bs-title="messageDisabledShareButton"
              data-bs-custom-class="custom-tooltip"
            >
              <button-social-share
                :disabled="!canDuplicateAndShare"
                :share-url="urlFull"
              />
            </div>
            <button
              class="btn border border-light-subtle m-1 m-xl-2 d-flex justify-content-center align-items-center"
              :style="{ width: '150px', height: '50px' }"
              @click="createNewAssembly"
            >
              Nuevo Ensamble
            </button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <search-bar
          v-if="activeAssemblyGroup != null"
          :min-price="minPrice"
          :max-price="maxPrice"
          :sort="sort"
          :max-page="maxPage"
          :current-page="currentPage"
          :secondary-searches="secondarySearches"
          :loading="loading"
          :active-assembly-group="activeAssemblyGroup"
          :all-categories="allCategories"
          :filters="filters"
        />

        <table-products
          :products="productsFinal"
          :loading="loading"
          :sort="sort"
          :brands="brandFilter"
          :stocks="stockFilter"
          :filters="filters"
          @update-table="updateTable"
          @add-assembly-product="addAssemblyProduct"
          @reset-assembly="reset"
          @skip-component="skipComponent"
          @delete-replace-component="deleteOrReplaceComponent"
        />
      </div>
      <div
        class="d-flex flex-column flex-xl-row mt-3"
        :class="[
          activeAssemblyGroup != null
            ? 'justify-content-between'
            : 'justify-content-center',
        ]"
      >
        <div class="col-12 col-xl-8 d-flex flex-row align-items-center px-2">
          <PaginationLimitSelector
            v-if="activeAssemblyGroup != null"
            class="col-5"
            @update-limit="updatePaginationLimit"
          />
          <Pagination
            v-if="activeAssemblyGroup != null"
            :max-page="maxPage"
            :current-page="currentPage"
            :loading="loading"
            class="col-7"
          />
        </div>
        <div
          class="d-flex justify-content-center justify-content-lg-end align-self-stretch col-12 col-xl-4 mt-3 mt-lg-3 mb-4"
        >
          <button
            v-if="nextActiveAssemblyGroup != null"
            class="btn btn-dark mx-1 px-2 px-md-4 d-flex flex-column justify-content-center align-items-center btn-footer-height"
            :disabled="prevActiveAssemblyGroup == null"
            :style="{ width: '180px' }"
            @click="prevAssemblyGroup()"
          >
            <span>
              <i class="bi bi-arrow-left me-1"></i>
              Anterior<br />
            </span>
            <small class="w-100 p-1 text-center">
              {{
                prevActiveAssemblyGroup ? prevActiveAssemblyGroup?.name : " "
              }}
            </small>
          </button>
          <button
            v-if="nextActiveAssemblyGroup != null"
            class="btn btn-dark mx-1 px-2 px-md-4 d-flex flex-column justify-content-center align-items-center btn-footer-height"
            :style="{ width: '180px' }"
            @click="nextAssemblyGroup()"
          >
            <span>
              Siguiente
              <i class="bi bi-arrow-right ms-1"></i><br />
            </span>
            <small class="w-100 p-1 text-center">
              {{
                nextActiveAssemblyGroup ? nextActiveAssemblyGroup?.name : " "
              }}
            </small>
          </button>
          <button
            v-else-if="pos != '1' && nextActiveAssemblyGroup == null"
            class="btn btn-danger mx-1 px-4 d-flex flex-column justify-content-center align-items-center position-relative btn-footer-height"
            :style="{ width: '180px' }"
            :disabled="loadingAssemblyConfirmationModal || !isAssemblyCompleted"
            @click="addProductToCart()"
          >
            <span> Agregar todo al carrito </span>
            <div
              v-if="loadingAssemblyConfirmationModal"
              class="position-absolute top-50 start-50 translate-middle"
            >
              <div class="spinner-border text-white" role="status">
                <span class="visually-hidden mx-auto">Loading...</span>
              </div>
            </div>
          </button>
          <button
            v-else-if="pos == '1' && nextActiveAssemblyGroup == null"
            class="btn btn-danger mx-1 px-4 d-flex flex-column justify-content-center align-items-center position-relative btn-footer-height"
            :style="{ width: '180px' }"
            :disabled="loadingAssemblyConfirmationModal || !isAssemblyCompleted"
            @click="addProductsPOS()"
          >
            <span> Agregar productos a POS </span>
            <div
              v-if="loadingAssemblyConfirmationModal"
              class="position-absolute top-50 start-50 translate-middle"
            >
              <div class="spinner-border text-white" role="status">
                <span class="visually-hidden mx-auto">Loading...</span>
              </div>
            </div>
          </button>
          <button
            v-if="
              activeAssemblyGroup &&
              !activeAssemblyGroup.is_required &&
              !hasOmitedProducts &&
              totalProductsByAssemblyGroup == 0
            "
            class="btn btn-outline-secondary ms-4 btn-footer-height d-none d-lg-inline"
            @click="skipComponent(activeAssemblyGroup)"
          >
            Omitir componente
            <i class="bi bi-skip-forward-fill"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="order-1 order-lg-2 col-12 col-lg-3 col-xl-2">
      <nav-categories
        :active-assembly-group="activeAssemblyGroup"
        :components="components"
        :accessories="accessories"
      />
    </div>
  </div>

  <product-info
    :show="showProductInfo"
    :product-id="productSelected"
    :product-slug="productSelectedSlug"
    :active-assembly-group="activeAssemblyGroup"
    @add-assembly-product="addAssemblyProduct"
  />
  <product-config
    :show="showProductConfig"
    :active-assembly-group="activeAssemblyGroup"
    :components="components"
    :accessories="accessories"
    @save-assembly="saveAssembly"
    @add-products-to-cart="addProductToCart"
    @add-products-to-pos="addProductsPOS"
    @delete-replace-component="deleteOrReplaceComponent"
    @update-show="(show: boolean) => (showProductConfig = show)"
  />

  <new-assembly-modal :show="showNewAssemblyModal" />

  <added-to-cart-modal
    :show="showModalAddProduct"
    :info="infoModalAddProduct"
    :errors="errorsModalAddProduct"
    @update-show="(show: boolean) => (showModalAddProduct = show)"
  />

  <AssemblyProductConfirmationModal
    :show="showConfirmationModal"
    :type="typeConfirmationModal"
    :product="productConfirmationModal"
    @update-show="(show: boolean) => (showConfirmationModal = show)"
  />

  <AssemblyConfirmationModal
    :show="showAssemblyConfirmationModal"
    :loading="loadingAssemblyConfirmationModal"
    @update-show="
      (newValue: boolean) => {
        showAssemblyConfirmationModal = newValue;
      }
    "
    @update-loading="
      (newValue: boolean) => {
        loadingAssemblyConfirmationModal = newValue;
      }
    "
    @save-products-in-cart="sendProductToCart"
  />
</template>

<script lang="ts">
import { AssemblyService } from "~/services/AssemblyService";
import { HomeService } from "~/services/HomeService";
import NavBreadcrumb from "@/components/navigation/NavBreadcrumb.vue";
import NavCategories from "@/components/assembly/NavCategories.vue";
import SearchBar from "@/components/assembly/SearchBar.vue";
import TableProducts from "@/components/assembly/TableProducts.vue";
import ProductInfo from "@/components/assembly/ProductInfo.vue";
import ProductConfig from "@/components/assembly/ProductConfig.vue";
import ButtonSocialShare from "@/components/buttons/ButtonSocialShare.vue";
import InputName from "@/components/assembly/InputName.vue";
import ErrorMessage from "@/components/common/ErrorMessage.vue";
import NewAssemblyModal from "@/components/assembly/NewAssemblyModal.vue";
import AddedToCartModal from "@/components/common/cart/AddedToCartModal.vue";
import AssemblyConfirmationModal from "@/components/assembly/AssemblyConfirmationModal.vue";
import AssemblyProductConfirmationModal from "@/components/assembly/AssemblyProductConfirmationModal.vue";
import { getLinkSelfTranslate, getTitleTranslate } from "@/utils/general";
import eventBus from "~/event-bus";
import { store } from "~/store";
import { mapGetters } from "vuex";
import { Jsona } from "jsona";
import auth from "~/services/AuthService";
import { MainSearchService } from "~/services/MainSearchService";
import type MainSearchResult from "~/models/MainSearchResult";
import type { IMainSearchFilter } from "~/models/MainSearchResult";
import Product from "~/models/Product";
import type AssemblyGroup from "~/models/AssemblyGroup";
import type { ICategory } from "~/models/Category";
import Pagination from "@/components/assembly/Pagination.vue";
import PaginationLimitSelector from "@/components/assembly/PaginationLimitSelector.vue";
// const { execute } = useReCaptcha();
// import { useInterval } from '~/composables/useInterval';
import { VITE_POS_URL } from "~/config/constants";
import type Brand from "~/models/Brand";
import { CustomNotifyService } from "~/services/CustomNotifyService";
import { CartService } from "~/services/CartService";
import type {
  AssemblyProduct,
  AssemblyConfigDetail,
  AssemblyConfig,
} from "~/store/modules/assembly";
import type { AxiosError } from "axios";
import { v4 as uuidv4 } from "uuid";
import { ProductService } from "~/services/ProductService";

const mainSearch = new MainSearchService();
const dataFormatter = new Jsona();
const notifyService = new CustomNotifyService();

interface FilterCompatibily {
  name: string;
  values: string;
  filter: string;
  status?: boolean;
}

type ProductWithPivot = Product & {
  pivot?: {
    qty?: number;
    assembly_group_id?: string | null;
  };
};

const resolveAssemblyGroupId = (
  assemblyGroup: string | AssemblyGroup | null | undefined,
) => {
  if (typeof assemblyGroup === "string") {
    return assemblyGroup;
  }

  return assemblyGroup?.id || null;
};

export default {
  components: {
    ButtonSocialShare,
    NavBreadcrumb,
    NavCategories,
    TableProducts,
    ProductConfig,
    ErrorMessage,
    ProductInfo,
    SearchBar,
    InputName,
    Pagination,
    PaginationLimitSelector,
    NewAssemblyModal,
    AddedToCartModal,
    AssemblyConfirmationModal,
    AssemblyProductConfirmationModal,
  },
  setup() {
    // useInterval(execute, 30000); // 30 segundos
    definePageMeta({
      name: "assembly-new",
      middleware: "re-captcha",
      layout: computed(() => {
        const route = useRoute();
        return route.query.pos ? "simple" : "default";
      }),
    });
    const route = useRoute();
    return {
      route,
    };
  },
  data: function () {
    return {
      secondary_text: "",
      filtersText: "",
      filters: [] as Array<FilterCompatibily>,
      filtersEnd: [] as Array<string>,
      sort: undefined as undefined | IMainSearchFilter,
      brandFilter: undefined as undefined | IMainSearchFilter,
      stockFilter: undefined as undefined | IMainSearchFilter,
      minPrice: 0,
      maxPrice: 999999,
      maxPage: 1,
      currentPage: 1,
      products: [] as Product[],
      loading: false,
      assemblyService: null as null | AssemblyService,
      productService: null as null | ProductService,
      showProductInfo: false,
      showProductConfig: false,
      productSelected: undefined as string | undefined,
      productSelectedSlug: undefined as string | undefined,
      isLargeScreen: false,
      urlFull: this.$route.fullPath,
      searchResult: null as null | MainSearchResult,
      components: [] as Array<AssemblyGroup>,
      accessories: [] as Array<AssemblyGroup>,
      showNewAssemblyModal: false as boolean,
      tooltipSave: null as import("bootstrap").Tooltip | null,
      tooltipDuplicate: null as import("bootstrap").Tooltip | null,
      tooltipShare: null as import("bootstrap").Tooltip | null,
      paginationLimit: 5 as number,
      brands: [] as Brand[],
      brandsLoading: false,
      showModalAddProduct: false as boolean,
      infoModalAddProduct: [] as [],
      errorsModalAddProduct: [],
      isSaving: false,
      prevHeight: 0 as number,
      showAssemblyConfirmationModal: false,
      loadingAssemblyConfirmationModal: false,
      showConfirmationModal: false,
      typeConfirmationModal: "",
      productConfirmationModal: null as null | Product,
      observer: null as null | ResizeObserver,
    };
  },
  computed: {
    hasCategories() {
      const assemblyGroup = this.filters.find(
        (item: FilterCompatibily) => item.name === "category",
      );
      if (assemblyGroup) {
        return true;
      }
      return false;
    },
    ...mapGetters("assembly", {
      productsSelected: "getProducts",
      selectedAssemblyConfig: "getSelectedAssemblyConfig",
      selectedAssemblyConfigId: "getSelectedAssemblyConfigId",
      activeAssemblyGroup: "getActiveAssemblyGroup",
      secondarySearches: "getSecondarySearches",
      allCategories: "getAllCategoriesInSecondarySearch",
      nextActiveAssemblyGroup: "getNextActiveAssemblyGroup",
      prevActiveAssemblyGroup: "getPrevActiveAssemblyGroup",
      isAssemblyCompleted: "isAssemblyCompleted",
    }),
    isUserAuthenticated() {
      return auth.isUserLogged();
    },
    visibleBrands() {
      return this.brands instanceof Array
        ? this.isLargeScreen
          ? this.brands.slice(0, 3)
          : this.brands.slice(0, 2)
        : [];
    },
    canSave() {
      return this.isUserAuthenticated;
    },
    canDuplicateAndShare() {
      return this.selectedAssemblyConfig
        ? this.selectedAssemblyConfig.id != null
        : false;
    },
    messageDisabledSaveButton() {
      return this.canSave ? "" : "Inicia sesión para guardar tu ensamble";
    },
    messageDisabledDuplicateButton() {
      return !this.isUserAuthenticated
        ? "Inicia sesión para duplicar tu ensamble"
        : !this.canDuplicateAndShare
          ? "Guarda tu ensamble para duplicarlo"
          : "";
    },
    messageDisabledShareButton() {
      return !this.isUserAuthenticated
        ? "Inicia sesión para compartir tu ensamble"
        : !this.canDuplicateAndShare
          ? "Guarda tu ensamble para compartirlo con tus amigos."
          : "";
    },
    buttonSaveId() {
      return "btn_save_" + Math.random() * 99;
    },
    buttonDuplicateId() {
      return "btn_duplicate_" + Math.random() * 99;
    },
    buttonShareId() {
      return "btn_share_" + Math.random() * 99;
    },
    productsFinal() {
      return this.activeAssemblyGroup != null
        ? this.products
        : this.productsSelected.map(
            (product: { product: Product; assemblyGroup: string }) => {
              return new Product({
                ...product.product,
                assembly_group: product?.assemblyGroup,
              });
            },
          );
    },
    hasProductOutOfStock() {
      return (
        this.productsSelected.filter((item: { product: Product }) => {
          return item.product.stock_providers + item.product.stock_stores == 0;
        }).length > 0
      );
    },
    pos() {
      const route = useRoute();
      const pos = route.query.pos;

      return pos as string;
    },
    dataBreadCrumb() {
      if (this.pos == "1") {
        return [
          {
            to: { self: "/arma-tu-equipo" },
            name: "Arma tu equipo",
            active: true,
          },
        ];
      }
      return [
        { to: { self: "/" }, name: "Inicio" },
        {
          to: { self: "/arma-tu-equipo" },
          name: "Arma tu equipo",
          active: true,
        },
      ];
    },
    hasOmitedProducts() {
      const exists = store.getters["assembly/hasOmitedProductsByAssemblyGroup"](
        this.activeAssemblyGroup?.id,
      );
      return exists;
    },
    totalProductsByAssemblyGroup() {
      return this.productsSelected.filter((product: AssemblyProduct) => {
        return product.assemblyGroup == this.activeAssemblyGroup?.id;
      })?.length;
    },
  },
  watch: {
    filtersText(newValue) {
      if (newValue.length > 0) {
        this.search();
      }
    },
    currentPage() {
      this.search();
    },
    activeAssemblyGroup(newActiveAssemblyGroup) {
      if (newActiveAssemblyGroup) {
        const slugGroup = newActiveAssemblyGroup.categories.map(
          function (category: { slug: string }) {
            return category.slug;
          },
        );
        this.changeFilters({
          name: "category",
          filter: this.getLink("assembly", "category"),
          values: slugGroup.join("."),
        });
      }
    },
    allCategories() {
      this.changeFilters(null);
    },
    productsSelected() {
      if (this.activeAssemblyGroup == null) {
        this.products = this.productsSelected.map(
          (product: { product: Product; assemblyGroup: string | null }) => {
            return new Product({
              ...product.product,
              assembly_group: resolveAssemblyGroupId(product.assemblyGroup),
            });
          },
        );
      }
    },
    secondarySearches: {
      handler(newSecondarySearches) {
        this.changeFilters({
          status: true,
          name: "secondary",
          filter: "/t_", // this.getLink("assembly", "text"),
          values: newSecondarySearches.join("."),
        });
      },
      deep: true,
      immediate: true,
    },
    "$route.fullPath"(newRoute) {
      this.urlFull = newRoute;
    },
    async "$route.params.id"(newId, oldId) {
      const route = useRoute();
      if (
        route.name != "assembly-new" &&
        route.name !=
          "assembly-edit" /* && route.name != "assembly-edit-with-cart" */
      ) {
        return;
      }
      if (newId != oldId) {
        this.changeAssemblyConfig(newId);
      }
    },
    messageDisabledSaveButton(newMessageDisabledSaveButton) {
      if (this.tooltipSave) {
        this.tooltipSave.setContent({
          ".tooltip-inner": newMessageDisabledSaveButton,
        });
        if (newMessageDisabledSaveButton == "") {
          this.tooltipSave.disable();
        } else {
          this.tooltipSave.enable();
        }
      }
    },
    messageDisabledDuplicateButton(newMessageDisabledDuplicateButton) {
      if (this.tooltipDuplicate) {
        this.tooltipDuplicate.setContent({
          ".tooltip-inner": newMessageDisabledDuplicateButton,
        });
        if (newMessageDisabledDuplicateButton == "") {
          this.tooltipDuplicate.disable();
        } else {
          this.tooltipDuplicate.enable();
        }
      }
    },
    messageDisabledShareButton(newMessageDisabledShareButton) {
      if (this.tooltipShare) {
        this.tooltipShare.setContent({
          ".tooltip-inner": newMessageDisabledShareButton,
        });
        if (newMessageDisabledShareButton == "") {
          this.tooltipShare.disable();
        } else {
          this.tooltipShare.enable();
        }
      }
    },
    selectedAssemblyConfig(newSelectedAssemblyConfig) {
      if (newSelectedAssemblyConfig.isSetName) {
        this.showNewAssemblyModal = false;
      }
    },
  },
  async created() {
    store.dispatch("assembly/setAssemblyGroups", []);
    if (!this.$route.params.assemblyId) {
      this.changeAssemblyConfig(this.$route.params.id as string);
    }
    this.assemblyService = new AssemblyService();
    this.productService = new ProductService();
    if (this.assemblyService) {
      this.assemblyService.getAssemblyInitData();
    }

    this.brandsLoading = true;
    try {
      this.brands = await this.assemblyService.getBrands(true);
    } finally {
      this.brandsLoading = false;
    }

    await this.assemblyService.getAssemblyGroups().then((data) => {
      if (data.length > 0) {
        this.components = data
          .filter((item: AssemblyGroup) => item.is_accessory == 0)
          .sort((a: AssemblyGroup, b: AssemblyGroup) => a.order - b.order);
        this.accessories = data
          .filter((item: AssemblyGroup) => item.is_accessory == 1)
          .sort((a: AssemblyGroup, b: AssemblyGroup) => a.order - b.order);

        if (this.productsSelected.length > 0) {
          store.commit("assembly/setActiveAssemblyGroup", null);
        } else {
          store.commit("assembly/setActiveAssemblyGroup", this.components[0]);
        }
      }
    });

    if (this.isUserAuthenticated) {
      await this.assemblyService.getAssemblyConfigsByCustomer();
    }

    if (!this.isUserAuthenticated) {
      store.commit("assembly/setAssemblyConfigs", []);
    }

    store.commit("setCanCloseMenu", true);
    store.commit("assembly/resetStockStatus");
    if (this.pos == "1") {
      const _route = useRoute();
      // if (reset == "1") {
      store.commit("assembly/resetNewAssemblyConfig");
      // }
      store.commit("assembly/setSelectedAssemblyConfigName", "POS");
      this.showNewAssemblyModal = false;
    }

    eventBus.on("save-assembly", (value: unknown) => {
      const valueFormatted = value as AssemblyGroup;
      this.saveAssembly(valueFormatted);
    });
    eventBus.on("change-filter-assembly", (value: unknown) => {
      const valueFormatted = value as FilterCompatibily;
      this.changeFilters(valueFormatted);
    });
    eventBus.on("change-current-page", (value: unknown) => {
      const valueFormatted = value as { page: number };
      this.currentPage = valueFormatted.page;
    });
    eventBus.on("toggle-show-product-info", (value: unknown) => {
      const valueFormatted = value as {
        open: boolean;
        productId: string;
        slug: string;
      };
      this.showProductInfo = valueFormatted.open;
      this.productSelected = valueFormatted.productId;
      this.productSelectedSlug = valueFormatted.slug;
    });

    eventBus.on("toggle-show-config", (value: unknown) => {
      this.showProductConfig = (value as { open: boolean }).open;
    });
  },
  async mounted() {
    const homeService = new HomeService();
    const brands = store.getters["catalogs/getDeserealizeBrands"];
    if (brands == undefined || brands.length == 0) {
      homeService.getBrands();
    }

    this.updateScreenSize();

    const { Tooltip } = await import("bootstrap");
    this.tooltipSave = new Tooltip("#" + this.buttonSaveId, {
      title: this.messageDisabledSaveButton,
    });
    this.tooltipDuplicate = new Tooltip("#" + this.buttonDuplicateId, {
      title: this.messageDisabledDuplicateButton,
    });
    this.tooltipShare = new Tooltip("#" + this.buttonShareId, {
      title: this.messageDisabledShareButton,
    });

    if (typeof window === "object") {
      window.addEventListener("message", this.handleMessageBound);
      // window.addEventListener("resize", this.updateScreenSize);
    }

    this.observer = new ResizeObserver(() => {
      this.updateScreenSize();
    });

    this.observer.observe(document.body);
  },
  beforeUnmount() {
    eventBus.off("change-filter-assembly");
    eventBus.off("change-current-page");
    eventBus.off("toggle-show-product-info");
    eventBus.off("toggle-show-config");

    this.tooltipSave?.dispose();
    this.tooltipDuplicate?.dispose();
    this.tooltipShare?.dispose();

    if (typeof window === "object") {
      window.removeEventListener("message", this.handleMessageBound);
      // window.removeEventListener("resize", this.updateScreenSize);
    }

    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    async search() {
      if (this.activeAssemblyGroup == null && this.productsSelected) {
        this.products = this.productsSelected.map(
          (product: { product: Product }) => {
            return new Product(product.product);
          },
        );
      } else if (
        this.activeAssemblyGroup != null &&
        this.assemblyService &&
        this.hasCategories
      ) {
        this.loading = true;
        try {
          this.searchResult = await mainSearch.search(
            this.currentPage,
            [...this.filtersEnd],
            this.paginationLimit,
            0,
            "",
            true,
          );
          let productsSelectedByGroup = this.productsSelected
            .filter((product: { assemblyGroup: string }) => {
              return product.assemblyGroup == this.activeAssemblyGroup?.id;
            })
            .map((product: { product: Product }) => {
              return new Product(product.product);
            });

          this.products = [];
          this.products = this.searchResult.data;
          if (productsSelectedByGroup.length > 0 && this.currentPage == 1) {
            productsSelectedByGroup = productsSelectedByGroup.map(
              (product: Product) => {
                const exist = this.products.find(
                  (seleccionado: Product) => seleccionado.id === product.id,
                );
                if (exist) {
                  product = exist;
                  store.commit("assembly/updateInfoProduct", {
                    id: product.id,
                    product: product,
                  });
                }
                return product;
              },
            );

            const merged = [
              ...productsSelectedByGroup,
              ...this.products,
            ].filter(
              (item: Product, index, self) =>
                index === self.findIndex((obj) => obj.id === item.id),
            );

            this.products = merged;
          }

          if (
            this.searchResult.errors &&
            this.searchResult.errors[0]?.meta?.route &&
            this.searchResult.errors[0]?.meta?.route[1] &&
            this.productService
          ) {
            const product = await this.productService.findBySlug(
              this.searchResult.errors[0].meta?.route[1] as string,
            );
            if (product.id) {
              let assembly_groups = [];
              const findCompatibilityFilter = this.filters.find(
                (item: FilterCompatibily) => item.name === "compatibility",
              );
              const values = findCompatibilityFilter
                ? findCompatibilityFilter.values
                : "";
              const response = await this.assemblyService.getAssemblyInfo(
                product.id,
                values,
              );
              if (response) {
                product.compatible = response?.compatible;
                product.stores_with_stock = response?.stores_with_stock;
                product.assembly_group_configs =
                  response?.assembly_group_configs;
                product.related_assembly_groups =
                  response?.related_assembly_groups;
                assembly_groups = response?.assembly_group_ids;
              }
              if (
                assembly_groups.find(
                  (item: string) => item == this.activeAssemblyGroup.id,
                )
              ) {
                this.products = [product];
              }
            }
          }

          if (
            this.searchResult.meta &&
            // this.searchResult.meta.filters &&
            this.searchResult.meta.prices
          ) {
            const minPrice = this.searchResult.meta.prices.min
              ? this.searchResult.meta.prices.min
              : 0;
            const maxPrice = this.searchResult.meta.prices.max
              ? this.searchResult.meta.prices.max
              : 999999;
            const maxPage = this.searchResult.meta.pagination.pages
              ? this.searchResult.meta.pagination.pages
              : 1;
            const currentPage = this.searchResult.meta.pagination.current_page
              ? this.searchResult.meta.pagination.current_page
              : 1;

            this.minPrice = Math.floor(minPrice / 100) * 100;
            this.maxPrice = Math.ceil(maxPrice / 100) * 100;

            this.maxPage = maxPage;
            this.currentPage = currentPage;
          }
          if (this.searchResult.meta && this.searchResult.meta.newFilters) {
            this.sort = this.searchResult.meta.newFilters.find((item) => {
              return item.code == "sort";
            });
            this.brandFilter = this.searchResult.meta.newFilters.find(
              (item) => {
                return item.code == "brand";
              },
            );
            this.stockFilter = this.searchResult.meta.newFilters.find(
              (item) => {
                return item.code == "stock";
              },
            );
          }
        } catch (err) {
          console.error(err);
        } finally {
          this.loading = false;
        }
      } else {
        this.products = [];
        this.minPrice = 0;
        this.maxPrice = 999999;
        this.maxPage = 1;
        this.currentPage = 1;
      }
    },
    isSelectedProduct(productId: string | null) {
      const exist = this.productsSelected.find(
        (product: { product_id: string }) => {
          return product.product_id == productId;
        },
      );
      return exist != undefined;
    },
    getTitle(section: string, name: string) {
      return getTitleTranslate(section, name);
    },
    getLink(section: string, name: string) {
      return getLinkSelfTranslate(section, name);
    },
    changeFilters(value: FilterCompatibily | null) {
      this.currentPage = 1;
      if (value != null) {
        const findFilter = this.filters.find(
          (item: FilterCompatibily) => item.name === value.name,
        );
        if (findFilter) {
          if (value.status === false || value.values == "") {
            this.filters = this.filters.filter(
              (item: FilterCompatibily) => item.name !== value.name,
            );
          } else {
            findFilter.values = value.values;
            findFilter.filter = value.filter;
          }
        } else {
          if (value.status !== false) {
            this.filters.push(value);
          }
        }
      }

      const findCompatibilityFilter = this.filters.find(
        (item: FilterCompatibily) => item.name === "compatibility",
      );
      const ids = store.getters["assembly/getIdProducts"];
      if (
        ids.length > 0 &&
        this.activeAssemblyGroup &&
        this.activeAssemblyGroup.all_products == 0
      ) {
        if (findCompatibilityFilter) {
          findCompatibilityFilter.values = ids.join(".");
          findCompatibilityFilter.filter = "/compatibilidad_";
        } else {
          this.filters.push({
            name: "compatibility",
            filter: "/compatibilidad_",
            values: ids.join("."),
          });
        }
      } else {
        if (findCompatibilityFilter) {
          findCompatibilityFilter.values = "";
        } else {
          this.filters.push({
            name: "compatibility",
            filter: "/compatibilidad_",
            values: "",
          });
        }
      }

      if (value && value.name == "secondary" && value.values == "") {
        this.filters = this.filters.filter(
          (item: FilterCompatibily) => item.name !== "secondary",
        );
      }

      if (value && value.name == "category") {
        this.filters = this.filters.filter(
          (item: FilterCompatibily) =>
            item.name !== "brand" && item.name !== "performance",
        );
        store.commit("assembly/resetBrands");
        store.commit("assembly/resetPerformances");
      }

      if (value && value.name != "price" && value.name != "order") {
        this.filters = this.filters.filter(
          (item: FilterCompatibily) => item.name !== "price",
        );
      }

      let filtersTemp = this.filters;
      if (this.allCategories) {
        filtersTemp = this.filters.filter(
          (item: FilterCompatibily) => item.name !== "price",
        );
        const slugGroups: Array<string> = [];
        this.components.map(function (item: AssemblyGroup) {
          slugGroups.push(
            item.categories
              .map(function (category: ICategory) {
                return category.slug;
              })
              .join("."),
          );
        });

        const filter = filtersTemp.find(
          (item: FilterCompatibily) => item.name === "category",
        );
        if (filter) {
          filter.values = slugGroups.join(".");
        }
      } else if (this.activeAssemblyGroup) {
        const slugGroup = this.activeAssemblyGroup.categories.map(function (
          category: unknown,
        ) {
          return (category as { slug: string }).slug;
        });

        const filter = filtersTemp.find(
          (item: FilterCompatibily) => item.name === "category",
        );
        if (filter) {
          filter.values = slugGroup.join(".");
        }
      }

      const sortFilter = this.filters.find(
        (item: FilterCompatibily) => item.name == "order",
      );
      if (!sortFilter) {
        filtersTemp.push({
          status: true,
          name: "order",
          filter: "/orden_sales-stock-stores",
          values: "",
        });
      }

      filtersTemp = filtersTemp.sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });

      let filtersTextTemp = "";
      filtersTemp.forEach((filter) => {
        if (filter.filter != undefined && filter.filter != "/") {
          filtersTextTemp += filter.filter;
          if (filter.values != undefined && typeof filter.values === "string") {
            filtersTextTemp += filter.values;
          }
        }
      });
      this.filtersEnd = filtersTemp
        .map((filter) => {
          let value = "";
          if (filter.filter != undefined && filter.filter != "/") {
            value += filter.filter.replace("/", "");
            if (
              filter.values != undefined &&
              typeof filter.values === "string"
            ) {
              value += filter.values;
            }
          }
          return value;
        })
        .filter((filter: string) => {
          return filter != "";
        });
      this.filtersText = filtersTextTemp;
    },
    searchSecondaryText() {
      eventBus.emit("change-filter-assembly", {
        status: true,
        name: "secondary",
        filter: this.getLink("assembly", "text"),
        values: this.secondarySearches.join("."),
      });
    },
    updateScreenSize() {
      this.isLargeScreen = window.innerWidth >= 1280;

      if (this.pos == "1") {
        this.setHeightInPos();
      }
    },
    saveAssembly(assemblyGroup?: AssemblyGroup | null) {
      this.isSaving = true;
      if (this.assemblyService && this.isUserAuthenticated) {
        if (this.selectedAssemblyConfig.id == null) {
          this.assemblyService
            .storeAssembly(this.selectedAssemblyConfig.name)
            .then(async (response) => {
              if (response && response.status == 201 && this.assemblyService) {
                const data: unknown = dataFormatter.deserialize(response.data);
                const dataFormatted = data as { slug: string };
                if (data) {
                  await this.assemblyService
                    .storeAssemblyDetails(data as Record<string, unknown>)
                    .then(async (response) => {
                      if (response) {
                        if (this.assemblyService) {
                          await this.assemblyService.getAssemblyConfigsByCustomer();
                        }
                        store.commit("assembly/resetProducts");
                        store.commit("assembly/resetNewAssemblyConfig");
                        let query = {};
                        if (this.pos) {
                          query = { pos: this.pos };
                        }
                        this.$router.push({
                          name: "assembly-edit",
                          params: { id: dataFormatted.slug },
                          query: query,
                        });
                        if (assemblyGroup != undefined) {
                          store.commit(
                            "assembly/setActiveAssemblyGroup",
                            assemblyGroup,
                          );
                          store.commit("assembly/setNextActiveAssemblyGroup");
                        }

                        notifyService.getNotification({
                          type: "success",
                          title: `Se guardó tu ensamble`,
                          text: `Se guardó correctamente tu ensamble`,
                          time: 3000,
                        });
                      } else {
                        notifyService.getNotification({
                          type: "error",
                          title: `Ocurrio un error al agregar los productos`,
                          text: "Ocurrio un error al agregar los productos",
                          time: 3000,
                        });
                      }
                    })
                    .catch((reason: AxiosError) => {
                      notifyService.getNotification({
                        type: "error",
                        title: `Ocurrio un error al agregar los productos`,
                        text: errorsToString(reason),
                        time: 3000,
                      });
                    });
                }
              } else {
                console.log("Error");
              }
            })
            .finally(() => {
              this.isSaving = false;
            });
        } else {
          this.assemblyService
            .updateAssembly(
              this.selectedAssemblyConfig.id,
              this.selectedAssemblyConfig.name,
            )
            .then(async (response) => {
              if (response && response.status == 200 && this.assemblyService) {
                const data: unknown = dataFormatter.deserialize(response.data);
                const dataFormatted = data as { slug: string };
                if (data) {
                  await this.assemblyService
                    .storeAssemblyDetails(data as Record<string, unknown>)
                    .then(async (response) => {
                      if (response) {
                        if (this.assemblyService) {
                          await this.assemblyService.getAssemblyConfigsByCustomer();
                        }
                        let query = {};
                        if (this.pos) {
                          query = { pos: this.pos };
                        }
                        this.$router.push({
                          name: "assembly-edit",
                          params: { id: dataFormatted.slug },
                          query: query,
                        });

                        notifyService.getNotification({
                          type: "success",
                          title: `Se guardó tu ensamble`,
                          text: `Se guardó correctamente tu ensamble`,
                          time: 3000,
                        });
                      } else {
                        notifyService.getNotification({
                          type: "error",
                          title: `Ocurrio un error al agregar los productos`,
                          text: `Ocurrio un error al agregar los productos`,
                          time: 3000,
                        });
                      }
                    })
                    .catch((reason: AxiosError) => {
                      notifyService.getNotification({
                        type: "error",
                        title: `Ocurrio un error al agregar los productos`,
                        text: errorsToString(reason),
                        time: 3000,
                      });
                    });
                  this.isSaving = false;
                }
              } else {
                this.isSaving = false;
                console.log("Error");
              }
            })
            .catch((reason: AxiosError) => {
              notifyService.getNotification({
                type: "error",
                title: `Ocurrio un error al actualizar el ensamble`,
                text: errorsToString(reason),
                time: 3000,
              });
            });
        }
      }
    },
    duplicateAssembly() {
      store.dispatch("assembly/duplicateAssemblyConfig");
      this.$router.push({ name: "assembly-new" });
    },
    async changeAssemblyConfig(newId: string) {
      if (this.assemblyService && this.isUserAuthenticated) {
        await this.assemblyService.getAssemblyConfigsByCustomer();
      }

      if (newId) {
        let assemblyConfigId: string | null = null;

        if (!this.assemblyService) {
          this.assemblyService = new AssemblyService();
        }

        try {
          const response = await this.assemblyService.showAssemblyBySlug(newId);
          const data: unknown = dataFormatter.deserialize(response);
          const dataFormatted = data as Array<{
            id: string;
            name: string;
            slug: string;
          }>;
          if (dataFormatted[0]) {
            assemblyConfigId = dataFormatted[0].id;
            store.commit(
              "assembly/setSelectedAssemblyConfig",
              assemblyConfigId,
            );
            store.commit("assembly/pushAssemblyConfigs", {
              id: dataFormatted[0].id,
              slug: dataFormatted[0].slug,
              name: dataFormatted[0].name,
              isSetName: true,
            });
          }
        } catch (error) {
          console.error(error);
        }

        if (this.assemblyService && assemblyConfigId) {
          this.loading = true;
          this.assemblyService
            .showAssembly(assemblyConfigId)
            .then((response) => {
              if (response) {
                const data = dataFormatter.deserialize(response);
                if (data) {
                  store.dispatch("assembly/addProducts", data);
                }
                this.showNewAssemblyModal = false;
                if (data.length > 0) {
                  store.commit("assembly/setActiveAssemblyGroup", null);
                } else {
                  store.commit(
                    "assembly/setActiveAssemblyGroup",
                    this.components[0],
                  );
                }
                data.forEach((product: { product: Product }) => {
                  if (product.product) {
                    this.getAssemblyGroupConfigByProduct(product.product);
                  }
                });
                this.changeFilters(null);
                this.loading = false;
              }
            });
        }
      } else {
        this.loading = true;
        store.commit("assembly/resetAssemblyConfig");
        if (this.productsSelected.length > 0) {
          store.commit("assembly/setActiveAssemblyGroup", null);
        } else {
          store.commit("assembly/setActiveAssemblyGroup", this.components[0]);
        }
        if (
          this.productsSelected.length == 0 &&
          !this.selectedAssemblyConfig.isSetName
        ) {
          this.showNewAssemblyModal = true;
        } else {
          this.showNewAssemblyModal = false;
        }
        this.search();
        this.loading = false;
      }
    },
    showAssembly() {
      store.commit("assembly/setActiveAssemblyGroup", null);
    },
    updatePaginationLimit(newLimit: number) {
      this.paginationLimit = newLimit;
      this.search();
    },
    goToLogin() {
      this.$router.push({
        name: "login",
      });
    },
    nextAssemblyGroup() {
      store.commit(
        "assembly/setActiveAssemblyGroup",
        this.nextActiveAssemblyGroup,
      );
    },
    prevAssemblyGroup() {
      store.commit(
        "assembly/setActiveAssemblyGroup",
        this.prevActiveAssemblyGroup,
      );
    },
    updateTable() {
      this.changeFilters(null);
    },
    reset() {
      store.commit("assembly/resetProducts");
      if (this.isUserAuthenticated && this.selectedAssemblyConfig.id != null) {
        this.saveAssembly(null);
      }
      if (this.components[0]) {
        store.commit("assembly/setActiveAssemblyGroup", this.components[0]);
      }
    },
    setHeightInPos() {
      const currHeight = Math.max(document.documentElement.scrollHeight, 500);
      if (Math.abs(this.prevHeight - currHeight) > 20) {
        this.prevHeight = currHeight;
        window.parent.postMessage(
          {
            type: "height",
            height: currHeight,
          },
          VITE_POS_URL,
        );
      }
    },
    async addProductToCart() {
      if (this.hasProductOutOfStock) {
        return true;
      }
      let isValid = true;
      if (this.assemblyService && this.selectedAssemblyConfig.id) {
        const data = await this.assemblyService.getValidAssembly(
          this.selectedAssemblyConfig.id,
        );
        if (data.status != "valid") {
          isValid = false;
          const list = data.errors.join("</li><li>");
          const text = `<ul><li class="my-2">${list}</li></ul>`;
          notifyService.getNotification({
            type: "error",
            title: `El ensamble tiene algunos detalles`,
            text: text,
          });
        }
      }

      if (isValid) {
        this.showAssemblyConfirmationModal = true;
      }
    },
    async sendProductToCart(requiredAssembly: boolean) {
      const cartService = new CartService();
      this.loadingAssemblyConfirmationModal = true;
      if (cartService && this.isUserAuthenticated) {
        this.errorsModalAddProduct = [];
        let promiseServe = null;
        if (this.$route.params.assemblyId) {
          const qty: unknown = this.$route.params.qty
            ? this.$route.params.qty
            : 1;
          const assemblyId = this.$route.params.assemblyId
            ? this.$route.params.assemblyId
            : "";
          const products: Array<AssemblyProduct> =
            store.getters["assembly/getFormatedProducts"];
          promiseServe = cartService.updateAssemblyQty(
            assemblyId as string,
            qty as number,
            products,
            requiredAssembly,
          );
        } else {
          promiseServe = cartService.addAssemblyProduct(requiredAssembly);
        }
        await promiseServe
          .then((response) => {
            if (response) {
              const dataFormatter = new Jsona();
              if (response.data) {
                const data = dataFormatter.deserialize(response);
                this.infoModalAddProduct = data as [];
                eventBus.emit("update-cart-total-items");
                this.showModalAddProduct = true;
              } else if (response.errors) {
                this.errorsModalAddProduct = response.errors;
                this.showModalAddProduct = true;
              }
            }
          })
          .catch((reason: AxiosError) => {
            notifyService.getNotification({
              type: "error",
              title: `Ocurrio un error al actualizar tu información`,
              text: errorsToString(reason),
              time: 3000,
            });
          })
          .finally(() => {
            this.showProductConfig = false;
          });
        this.loadingAssemblyConfirmationModal = false;
        this.showAssemblyConfirmationModal = false;
      } else if (cartService && !this.isUserAuthenticated) {
        let errorValidateProduct = false;
        this.errorsModalAddProduct = [];
        const infoModalAddProductTemp: Array<unknown> = [];
        const products = store.getters["assembly/getFormatedProducts"];
        let assemblyId: string = uuidv4();
        let totalAssemblies: number = 1;
        if (this.$route.params.assemblyId) {
          assemblyId = this.$route.params.assemblyId as string;
        }
        if (this.$route.params.qty) {
          totalAssemblies = +this.$route.params.qty as number;
        }
        products.forEach(
          async (product: { [key: string]: string }, index: number) => {
            if (cartService && !errorValidateProduct && product["product_id"]) {
              await cartService
                .validateAddProduct(+product["product_id"], 0)
                .then((response) => {
                  if (response) {
                    const dataFormatter = new Jsona();
                    if (response.data) {
                      const data: unknown = dataFormatter.deserialize(response);
                      const dataFormatted = data as Array<{
                        quantity: number;
                        assembly_id: string;
                        assembly_name: string;
                        qty_by_assembly: number;
                        product: AssemblyGroup;
                        is_updated: boolean;
                      }>;
                      if (dataFormatted[0]) {
                        dataFormatted[0].assembly_id = assemblyId;
                        dataFormatted[0].qty_by_assembly =
                          dataFormatted[0].quantity;
                        dataFormatted[0].quantity =
                          dataFormatted[0].qty_by_assembly * totalAssemblies;
                        dataFormatted[0].product.is_accessory = 0;
                        dataFormatted[0].is_updated = true;
                        dataFormatted[0].assembly_name =
                          this.selectedAssemblyConfig.name;
                        infoModalAddProductTemp.push(dataFormatted[0]);

                        const productData = {
                          productId: product["product_id"],
                          qty:
                            dataFormatted[0].qty_by_assembly * totalAssemblies,
                          assemblyId: assemblyId,
                          assemblyGroupId: product["assembly_group_id"],
                          assemblyName: this.selectedAssemblyConfig.name,
                        };
                        store.dispatch("cart/addProductIdInLocal", productData);
                        store.dispatch(
                          "cart/addProductToCart",
                          dataFormatted[0],
                        );
                        eventBus.emit("update-cart-total-items");
                      }
                    } else if (response.errors) {
                      errorValidateProduct = true;
                      this.errorsModalAddProduct.concat(response.errors);
                    }
                  }

                  if (!errorValidateProduct && index == products.length - 1) {
                    this.infoModalAddProduct = infoModalAddProductTemp as [];
                    this.showModalAddProduct = true;
                  } else {
                    this.showModalAddProduct = true;
                  }
                });
            }
          },
        );

        const productsOmitted =
          store.getters["assembly/getFormatedOmittedProducts"];
        productsOmitted.forEach(
          (product: { [key: string]: string }, _index: number) => {
            if (product["product_id"] == undefined) {
              const productData = {
                productId: null,
                qty: 0,
                assemblyId: assemblyId,
                assemblyGroupId: product["assembly_group_id"],
                assemblyName: this.selectedAssemblyConfig.name,
              };
              store.dispatch("cart/addProductIdInLocal", productData);
            }
          },
        );

        this.showProductConfig = false;
        this.loadingAssemblyConfirmationModal = false;
        this.showAssemblyConfirmationModal = false;
      }
    },
    getAssemblyGroupConfigByProduct(product: Product) {
      if (
        product.assembly_group_configs &&
        product.assembly_group_configs.length > 0
      ) {
        const dataCommit = product.assembly_group_configs.map(
          (item: unknown) => {
            const itemFormatted = item as {
              id: string;
              max: number;
              note?: string;
            };
            return {
              id: itemFormatted.id,
              product_id: product.id,
              max: itemFormatted.max ? itemFormatted.max * 1 : 1,
              note: itemFormatted.note ? itemFormatted.note : "",
            };
          },
        );
        store.dispatch("assembly/updateAssemblyGroups", dataCommit);
      } else if (this.productService) {
        this.productService
          .getProductAssemblyGroups(product.id as string)
          .then((response) => {
            const data = dataFormatter.deserialize(response);
            if (data.length > 0) {
              if (Array.isArray(data)) {
                const dataCommit = data.map((item: unknown) => {
                  const itemFormatted = item as {
                    id: string;
                    max: number;
                    note?: string;
                  };
                  return {
                    id: itemFormatted.id,
                    product_id: product.id,
                    max: itemFormatted.max ? itemFormatted.max * 1 : 1,
                    note: itemFormatted.note ? itemFormatted.note : "",
                  };
                });
                store.dispatch("assembly/updateAssemblyGroups", dataCommit);
              } else {
                store.dispatch("assembly/updateAssemblyGroups", [
                  {
                    id: data.id,
                    product_id: product.id,
                    max: data.max ? data.max * 1 : 1,
                    note: data.note ? data.note * 1 : 1,
                  },
                ]);
              }
            }
          });
      }
    },
    async getProductsByProduct(productId: string) {
      this.loading = true;
      const response =
        await this.assemblyService?.getComponentsByProduct(productId);
      const data = dataFormatter.deserialize(response) as ProductWithPivot[];
      const products = [] as Array<AssemblyConfigDetail>;
      data.forEach((item: ProductWithPivot, index: number) => {
        const product: AssemblyConfigDetail = {
          id: index.toString(),
          product: item as unknown as Product,
          assemblyGroup: {
            id: item.pivot?.assembly_group_id || "",
          } as AssemblyGroup,
          assemblyConfig: {
            id: null,
          } as AssemblyConfig,
          qty: item.pivot?.qty ? item.pivot.qty : 0,
        };
        products.push(product);
      });
      store.dispatch("assembly/addProducts", products);
      // store.commit("assembly/setActiveAssemblyGroup", null);
      // this.search();
      this.loading = false;
    },
    handleMessageBound(ev: MessageEvent) {
      if (ev.data && ev.data.type === "assembly-pos") {
        if (ev.data.product_id) {
          this.getProductsByProduct(ev.data.product_id);
        }
      }

      if (ev.data && ev.data.type === "assembly-error-pos") {
        this.showAssemblyConfirmationModal = false;
        this.loadingAssemblyConfirmationModal = false;
        const list = ev.data.errors
          .map((error: { message: string }) => error.message)
          .join("</li><li>");
        const errorText = `<ul><li>${list}</li></ul>`;

        notifyService.getNotification({
          type: "error",
          title: `Ocurrio un error al agregar los productos`,
          text: errorText,
          time: 3000,
        });
      }
    },
    addProductsPOS() {
      this.showAssemblyConfirmationModal = true;
    },
    createNewAssembly() {
      store.commit("assembly/resetNewAssemblyConfig");
      let query = {};
      if (this.pos) {
        query = { pos: this.pos };
      }
      this.$router.push({
        name: "assembly-new",
        query: query,
      });
    },
    async skipComponent(group: AssemblyGroup) {
      if (
        this.selectedAssemblyConfigId &&
        this.isUserAuthenticated &&
        !this.$route.params.assemblyId
      ) {
        const assemblyService = new AssemblyService();
        await assemblyService
          .storeAssemblyDetail(this.activeAssemblyGroup.id)
          .then((response) => {
            if (response) {
              const data = dataFormatter.deserialize(response.data);
              store.commit("assembly/addOmitedProduct", data);
            }
            return response;
          })
          .catch((reason: AxiosError) => {
            notifyService.getNotification({
              type: "error",
              title: `Ocurrio un error al agregar el producto`,
              text: errorsToString(reason),
              time: 3000,
            });
          });

        store.commit("assembly/setNextActiveAssemblyGroup");

        assemblyService
          .showAssembly(this.selectedAssemblyConfigId)
          .then((response) => {
            if (response) {
              const data = dataFormatter.deserialize(response);
              if (data) {
                store.dispatch("assembly/addProducts", data);
              }
            }
          });
      } else {
        const data = {
          id: null,
          assemblyConfig: { id: null },
          assemblyGroup: { id: group.id },
        };
        store.commit("assembly/addOmitedProduct", data);
        store.commit("assembly/setNextActiveAssemblyGroup");
      }
    },
    deleteOrReplaceComponent(value: {
      show: boolean;
      type: string;
      product: Product;
    }) {
      this.showConfirmationModal = value.show;
      this.typeConfirmationModal = value.type;
      this.productConfirmationModal = value.product;
    },
    async addAssemblyProduct(product: Product) {
      if (this.productService && product.id) {
        this.getAssemblyGroupConfigByProduct(product);
      }
      if (
        this.assemblyService &&
        product.id &&
        this.isUserAuthenticated &&
        this.selectedAssemblyConfig.id == null &&
        this.pos != "1" &&
        !this.$route.params.assemblyId
      ) {
        store.dispatch("assembly/addProduct", {
          product: product,
          assemblyGroup: this.activeAssemblyGroup?.id,
        });
        if (this.pos != "1") {
          this.saveAssembly(null);
        }
      } else if (
        this.assemblyService &&
        product.id &&
        this.isUserAuthenticated &&
        this.pos != "1" &&
        !this.$route.params.assemblyId
      ) {
        const response = await this.assemblyService
          .storeAssemblyDetail(this.activeAssemblyGroup.id, product.id, 1)
          .then((response) => {
            return response;
          })
          .catch((reason: AxiosError) => {
            notifyService.getNotification({
              type: "error",
              title: `Ocurrio un error al agregar el producto`,
              text: errorsToString(reason),
              time: 3000,
            });
          });
        if (response && response?.status == 201) {
          this.showProductInfo = false;
          this.showProductConfig = true;
          if (this.nextActiveAssemblyGroup != null) {
            setTimeout(() => {
              this.showProductConfig = false;
            }, 1500);
          }
          const data = dataFormatter.deserialize(response.data) as {
            id: number;
          };
          store.dispatch("assembly/addProduct", {
            id: data?.id,
            product: product,
            assemblyGroup: this.activeAssemblyGroup?.id,
          });

          if (
            store.getters["assembly/hasOmitedProductsByAssemblyGroup"](
              this.activeAssemblyGroup.id,
            )
          ) {
            store.commit(
              "assembly/removeOmitedProduct",
              this.activeAssemblyGroup.id,
            );
          }

          if (this.activeAssemblyGroup != null) {
            store.commit("assembly/setNextActiveAssemblyGroup");
          } else {
            store.dispatch(
              "assembly/setNextActiveAssemblyGroupByProduct",
              product.id,
            );
          }

          this.assemblyService
            .showAssembly(this.selectedAssemblyConfigId)
            .then((response) => {
              if (response) {
                const data = dataFormatter.deserialize(response);
                if (data) {
                  store.dispatch("assembly/addProducts", data);
                }
              }
            });
        }
      } else {
        this.showProductInfo = false;
        this.showProductConfig = true;
        if (this.nextActiveAssemblyGroup != null) {
          setTimeout(() => {
            this.showProductConfig = false;
          }, 1500);
        }
        store.dispatch("assembly/addProduct", {
          product: product,
          assemblyGroup: this.activeAssemblyGroup?.id,
        });

        if (
          store.getters["assembly/hasOmitedProductsByAssemblyGroup"](
            this.activeAssemblyGroup.id,
          )
        ) {
          store.commit(
            "assembly/removeOmitedProduct",
            this.activeAssemblyGroup.id,
          );
        }

        store.commit("assembly/setNextActiveAssemblyGroup");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.row-product::before {
  content: "";
  width: 0%;
  height: 100%;
  background-color: var(--bs-gray-100);
  position: absolute;
  z-index: -1000;
  top: 0;
  left: 0;
  opacity: 0;
  transition: all 0.5s ease-out;
}

.row-product:hover::before {
  opacity: 100;
  width: 100%;
}

.custom-tooltip {
  --bs-tooltip-bg: var(--bs-red);
  --bs-tooltip-color: var(--bs-white);
  --bs-tooltip-padding-x: 5px;
  --bs-tooltip-padding-y: 5px;
  --bs-tooltip-opacity: 1;
}

.btn-footer-height {
  min-height: 60px !important;
}
</style>
